<button
  [disabled]="disabled || loading"
  [type]="type || ''"
  [ngClass]="{
    'btn-primary': variant === 'primary',
    'btn-secondary-color': variant === 'info',
    'btn-secondary-gray': variant === 'outline',
    'btn-secondary-primary': variant === 'primary-outline',
    'btn-destructive-primary': variant === 'danger',
    'bg-white hover:bg-gray-25': variant === 'light',
    'bg-white text-[#D92D20] border border-[#D92D20]':
      variant === 'danger-outline',
    'btn-primary-outline': variant === 'primary-outline'
  }"
  [class]="'btn btn-md w-max flex items-center gap-1 ' + class"
  (click)="onClick.emit(label)"
>
  <span class="order-2">{{ label }}</span>
  <i
    *ngIf="!!icon"
    [class]="icon"
    [ngClass]="iconPosition === 'right' ? 'order-3' : 'order-1'"
  ></i>
  <i *ngIf="loading" class="pi pi-spin pi-spinner order-4"></i>
</button>
